import Vue from 'vue';
import Vuex from 'vuex';
// Tell vue to use vuex
Vue.use(Vuex);
import fdns from './modules/FDNS/index.js'

import profile from './modules/Profile/index.js'

import Notification from './modules/Notification/index.js'

import Timesheets from   './modules/Timesheets/index.js'

import Project from './modules/Profile/Project/index.js'

export default  new Vuex.Store({
    //imported store files will be named inside modules object
    modules: {
        fdns:fdns,
        profile: profile,
        Notification: Notification,
        Timesheets:Timesheets,
        Project : Project
    },


    state: {
        timesheetModuleName: 'Timesheets', // Default label, will be fetched from settings
    },
    mutations: {
        updateTimesheetModuleName(state, label) {
            state.timesheetModuleName = label || 'Timesheets';
        }
    },
    getters: {
        getTimesheetModuleName(state) {
            return state.timesheetModuleName;
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js